import WorkshopPhoto from "../../../assets/images/jpeg/build/ai-consulting-workshop.jpg";
import BuildChallengeForm from "./BuildChallengeForm";

const proofPoints = [
  "Start with the problem",
  "No technical brief required",
  "Leave with something working",
];

const BuildHeroSection = () => {
  return (
    <section className="apl-hero" id="top">
      <div className="apl-shell apl-hero-grid">
        <div className="apl-hero-copy apl-reveal">
          <div className="apl-lab-tag">
            <i />
            Utiva AI Product Lab
          </div>
          <h1>
            Your business problem could become your next{" "}
            <span>AI product.</span>
          </h1>
          <p className="apl-lede">
            Bring us the friction, bottleneck or opportunity. We bring the
            product team to turn it into a working AI solution your organisation
            can test.
          </p>
          <div className="apl-hero-actions">
            <a className="apl-btn apl-btn-gold" href="#apply">
              Submit a Challenge
            </a>
            <a className="apl-btn apl-btn-ghost" href="#method">
              See How the Lab Works
            </a>
          </div>
          <div className="apl-hero-proof">
            {proofPoints.map((point) => (
              <span key={point}>
                <i />
                {point}
              </span>
            ))}
          </div>
          <figure className="apl-hero-photo">
            <img
              src={WorkshopPhoto}
              alt="African product and business professionals collaborating around a laptop in an AI product lab session"
            />
            <figcaption>
              <small>Inside the lab</small>
              Business context and product thinking meet at the same table.
            </figcaption>
          </figure>
        </div>

        <BuildChallengeForm />
      </div>
    </section>
  );
};

export default BuildHeroSection;
